<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: -7rem !important;">
    <div v-if="$getSiteId() == 35" class="page-header-card mb-3 nav-green-gradient-bg">
      <div class="vx-row">
        <div class="vx-col w-full">
          <img style="margin-top: 2.4rem;" src="../assets/images/digicampus-white-small-high.png" alt="DigiCampus Logo (white)">
        </div>
      </div>
    </div>
    <div v-else-if="$getSiteId() == 33" class="page-header-card mb-3 nav-orange-gradient-bg">
      <div class="vx-row">
        <div class="vx-col w-full">
          <img style="max-width: 190px;" src="../assets/images/bheka-funda-digi-merged-logo.png" alt="Bheka Funda Logo (white)">
        </div>
      </div>
    </div>
    <div v-else class="page-header-card mb-3 nav-redish-gradient-bg">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col w-full text-center">
              <custom-svg variant="globe" width="60" height="60" color="white" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">sonke learning</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showLoading" class="mx-4" style="margin-top: -80px;">
      <custom-skeleton size="large" :count="4" />
    </div>
    <div v-else id="learn-list" class="mx-4" style="margin-top: -80px;">
      <div style="border-radius: 30px; background-color: rgba(0,0,0,0.5);" class="mb-3 green-border border-3px cursor-pointer" @click="continueLearning" :class="false ? 'disabled':''">
        <div class="vx-row menu-item-container-of-content">
          <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
            <div class="vx-row">
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon continue--icon" variant="continue" color="green" />
              </div>
              <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <p class="mb-n2 font-brightgreen sonke-menu-heading" style="font-weight: 600;letter-spacing: -2px;">continue</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <h4 class="sonke-menu-sub-heading">learning</h4>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon arrow--icon" variant="arrow" color="white" dir="right" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="border-radius: 30px;" class="mb-3 nav-dark-gradient-bg_invert border-3px cursor-pointer" :class="{ 'gen2-orange-border' : $getSiteId() == 33, 'gen2-red-dark-border' : $getSiteId() != 33 }" @click="learningPrograms">
        <div class="vx-row menu-item-container-of-content">
          <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
            <div class="vx-row">
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon globe--icon" variant="globe" :color="$getSiteId() == 33 ? 'gradient-orange' : 'gradient-light'" />
              </div>
              <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <p class="mb-n2 sonke-menu-heading" :class="{ 'font-gen2-gradient-orange_invert' : $getSiteId() == 33, 'font-gen2-gradient-light_invert' : $getSiteId() != 33 }" style="font-weight: 600;letter-spacing: -2px;">learning</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <h4 class="sonke-menu-sub-heading">programs</h4>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon arrow--icon" variant="arrow" :color="$getSiteId() == 33 ? 'gradient-orange' : 'gradient-light'" dir="right" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="status-up-to-date" style="border-radius: 30px; background-color: #ffffff;" class="mb-3 gen2-red-dark-border border-3px">
        <div class="vx-row" style="padding: 1.5rem">
          <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
            <div class="vx-row">
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg variant="action" width="55" height="55" color="gradient-dark" />
              </div>
              <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <p class="mb-n2 font-gen2-gradient-dark" style="font-size: 2.1rem;font-weight: 600;letter-spacing: -2px;">status</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <h4 style="color: #929292">up to date</h4>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">v
                <custom-svg variant="check-circle" width="50" height="50" color="gradient-dark" />
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div id="status-need-action" style="border-radius: 30px;" :style="{ 'background-color': (noAction || inProgress) ? '#ffffff' : '#353535' }" class="mb-3 border-3px cursor-pointer" :class="{ 'gen2-orange-border' : $getSiteId() == 33 && (noAction || inProgress), 'gen2-red-dark-border' : $getSiteId() == 35 && (noAction || inProgress), 'green-border' : actionNeeded }" @click="courseProgress">
        <div class="vx-row menu-item-container-of-content">
          <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
            <div class="vx-row">
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon status--icon" variant="action" width="55" height="55" :color="$getSiteId() == 33 && (noAction || inProgress) ? 'gradient-orange' : $getSiteId() == 35 && (noAction || inProgress) ? 'gradient-dark' : 'green'" />
              </div>
              <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <p class="mb-n2 sonke-menu-heading" :class="{ 'font-brightgreen' : actionNeeded, 'font-gen2-gradient-orange' : $getSiteId() == 33 && (noAction || inProgress), 'font-gen2-gradient-dark' : $getSiteId() == 35 && (noAction || inProgress) }" style="font-weight: 600;letter-spacing: -2px;">status</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <h4 v-if="showLoadingText" class="sonke-menu-sub-heading">loading...</h4>
                    <h4 v-else class="sonke-menu-sub-heading" :style="{ 'color': (noAction || inProgress) ? '#929292' : '#ebeefd' }">{{ mainStatusToDisplay || 'click to see status' }}</h4>
                    <!-- <h4>need action</h4>  :style="{ 'color': actionNeeded ? '#929292' : '#ebeefd' }"-->
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg v-if="actionNeeded || inProgress" class="menu--icon arrow--icon" variant="arrow" :color="actionNeeded ? 'white' : $getSiteId() == 33 ? 'gradient-orange' : 'gradient-dark'" dir="right" />
                <custom-svg v-else class="menu--icon" variant="check-circle" height="48" width="48" :color="$getSiteId() == 33 ? 'gradient-orange' : 'gradient-dark'" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMentoringAvailable" style="border-radius: 30px; background-color: #ffffff;" class="mb-3 border-3px cursor-pointer" :class="{ 'gen2-orange-border' : $getSiteId() == 33, 'gen2-red-dark-border' : $getSiteId() != 33 }" @click="mentoring">
        <div class="vx-row menu-item-container-of-content">
          <div class="vx-col w-full" style="padding-left: 1rem; padding-right: 1rem;">
            <div class="vx-row">
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon chat--icon" variant="chat" color="gradient-dark" />
              </div>
              <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <p class="mb-n2 font-gen2-gradient-dark sonke-menu-heading" style="font-weight: 600;letter-spacing: -2px;">mentorship</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                    <h4 class="sonke-menu-sub-heading" style="color: #929292">and support</h4>
                  </div>
                </div>
              </div>
              <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
                <custom-svg class="menu--icon arrow--icon" variant="arrow" color="gradient-dark" dir="right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      showLoading: false,
      isMentoringAvailable: false,
      progressData: [],
      courseProgressStucture:[],
      showLoadingText: true,
      mainStatusToDisplay: "",
      actionNeeded: false,
      inProgress: false,
      noAction: false
    };
  },
  computed: {
    
  },
  methods: {
    continueLearning() {
      this.$router.push({ name: 'Gen2LearningPrograms', query: { ref: 'continue' } });
    },
    learningPrograms() {
      this.$router.push({ name: 'Gen2LearningPrograms' });
    },
    isMentoringAvailableFunction(){
      var self = this;
      var onSuccess = response => {
        self.isMentoringAvailable = response.data;
        localStorage.setItem("mentoringAvailable", self.isMentoringAvailable);
      };
      var onFinally = response => {
        self.showLoading = false;
      };
      self.$ajaxGet(self, "Site/IsMentoringAvailable", onSuccess, onFinally);
    },
    mentoring() {
      this.$router.push({ name: 'Gen2Mentorships' });
    },
    courseProgress() {
      this.$router.push({ name: 'Gen2CourseProgress', params: { progressData: JSON.stringify(this.progressData), courseProgressStucture: JSON.stringify(this.courseProgressStucture) } });
    },
    checkIfTimeCapturingRequired() {
      var self = this;
      self.showLoading = true;
      var onSuccess = response => {
        if (response.data && response.data != 0) {
          self.showLoading = false;
          setTimeout(() => {
            if (response.data == 1) {
              self.$router.push({ name: 'Gen2TimeCapture' });
            } else if (response.data == 2) {
              self.$router.push({ name: 'Gen2PracticalTimeCapture' });
            }
          }, 100);
        } else {
          self.isMentoringAvailableFunction();
        }
      };
      self.$ajaxGet(self, "Student/CheckTimeCapture", onSuccess);
    },
    getProgressData(){
      var self = this;
      self.showLoadingText = true;

      var onSuccess = response =>{
        self.progressData = response.data;

        if (self.progressData.length > 0) {
          var actionNeededList = self.progressData.filter(x => x.actionNeeded);
          var inProgressList = self.progressData.filter(x => !x.courseComplete);
          if (actionNeededList.length > 0) {
            self.mainStatusToDisplay = "action needed";
            self.actionNeeded = true;
          } else if (inProgressList.length > 0) {
            self.mainStatusToDisplay = "in progress";
            self.inProgress = true;
          } else {
            self.mainStatusToDisplay = "up-to-date";
            self.noAction = true;
          }
          return;
        }
      }
    
      var onFinally = response =>{
        self.showLoadingText = false;
        self.getActionableTasks();
      }
    
      self.$ajaxGet(self, "Course/GetCourseProgressOverview", onSuccess, onFinally);
    },
    getActionableTasks(){
      var self = this;
      var onSuccess = response =>{
        self.courseProgressStucture = response.data;
        self.showLoadingText = false;
      }

      if(self.progressData){
        var sendData = self.progressData.filter(x=>x.actionNeeded);
        if(sendData){
          self.$ajaxPost(self, "Course/GetActionableTasks", sendData, onSuccess);
        }
      }
    }
  },
  mounted() {
    var self = this;

    localStorage.removeItem("mentoringAvailable");
    
    self.isMentoringAvailableFunction();
    // self.checkIfTimeCapturingRequired();

    self.getProgressData();
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>